import React from 'react';
import {
  FiBarChart2,
  FiFileText,
  FiLayers,
  FiMail,
  FiUser,
  FiUsers,
  FiZap
} from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';

import { CgExtensionAdd } from 'react-icons/cg';

const FiHomeComponent = CgExtensionAdd as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiMailComponent = FiMail as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiZapComponent = FiZap as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiLayersComponent = FiLayers as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiUsersComponent = FiUsers as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiBarChart2Component = FiBarChart2 as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiFileTextComponent = FiFileText as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;
const FiUserComponent = FiUser as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const Sidebar: React.FC = () => {
  const location = useLocation();

  // Defines the menu items for the sidebar navigation
  // Each item includes a path, label, and corresponding icon component
  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: FiHomeComponent },
    { path: '/campaigns', label: 'Campaigns', icon: FiMailComponent },
    { path: '/automations', label: 'Automations', icon: FiZapComponent },
    { path: '/templates', label: 'Templates', icon: FiLayersComponent },
    { path: '/audience', label: 'Audience', icon: FiUsersComponent },
    { path: '/segments', label: 'Segments', icon: FiUsersComponent },
    { path: '/analytics', label: 'Analytics', icon: FiBarChart2Component },
    { path: '/reports', label: 'Reports', icon: FiFileTextComponent },
    { path: '/team', label: 'Team', icon: FiUserComponent },
  ];

  return (
    <aside className='w-56 bg-white p-4'>
      <nav>
        <ul className='space-y-2'>
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`p-2 rounded flex items-center ${location.pathname === item.path
                  ? ''
                  : 'text-gray-600 hover:bg-gray-100'
                  }`}
                style={
                  location.pathname === item.path
                    ? { backgroundColor: '#E0F8FB', color: '#00899E' }
                    : {}
                }
              >
                <item.icon
                  size={item.label === 'Dashboard' ? 20 : 16}
                  className={item.label === 'Dashboard' ? 'mr-2' : 'mr-3'}
                />
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
